export const projects = [
  {
    slug: "cudo",
    name: "CUDO Compute",
    sector: "AI Compute · Infrastructure",
    year: "2024 - 2026",
    role: "Content & Editorial Lead",
    url: "https://www.cudocompute.com/",
    summary:
      "Led content and editorial strategy across CUDO Compute and CUDOS, covering AI infrastructure, GPU compute, HPC, sovereign cloud, and permissionless Web3 compute. Turned complex technical topics into clear, buyer-facing narratives across blogs, whitepapers, newsletters, landing pages, tutorials, sales enablement, and social campaigns, owning the full editorial engine for two sister brands at once and on-site coverage at the industry's biggest AI and Web3 events.",
    metrics: [
      { value: "+88% YoY", label: "Impressions" },
      { value: "+97% YoY", label: "Engagements & clicks" },
      { value: "+205% YoY", label: "Video views" },
      { value: "+92% YoY", label: "Follower growth" },
      { value: "9.2M+", label: "Total impressions" },
      { value: "400+ clips", label: "Short clips from 50 long-form interviews" },
      { value: "+312%", label: "LinkedIn engagement YoY" },
      { value: "+178%", label: "YouTube watch-time YoY" },
    ],
    proofs: [
      "Owned the full editorial engine: blog, whitepapers, newsletters, landing pages, tutorials, sales enablement, and exec ghostwriting",
      "Ran social end-to-end across X, LinkedIn, YouTube, and Telegram for both CUDO Compute and CUDOS",
      "On-site content lead at NVIDIA GTC, Web Summit, and Token2049, live coverage, interviews, and post-event recap engines",
      "Translated GPU, HPC, sovereign cloud, and permissionless compute into clear buyer-facing narratives for AI builders, enterprises, and Web3 partners",
      "Built AI-assisted research, drafting, and reporting workflows that let a small team ship like a much larger one",
      "Partnered directly with product, design, sales, and exec teams to align messaging across launches, fundraises, and partnerships",
      "Repositioned CUDOS narrative around permissionless compute, sharpening differentiation vs. centralized cloud",
      "Sustained year-over-year growth across every primary surface: impressions, engagement, video views, and followers",
    ],
  },
  {
    slug: "thunderbolt",
    name: "Thunderbolt Technologies + Intel",
    sector: "Consumer Tech · Paid & Organic Social",
    year: "2017 - 2023",
    role: "Social Lead & Reporting",
    url: "https://www.thunderbolttechnology.net/",
    summary:
      "Owned social media management, content curation, community engagement, and campaign reporting across consumer technology accounts, including six-figure paid social, sponsored sweepstakes, and recurring analytics. Sub-feature: supported Intel and Intel Canada activations through Thunderbolt/MMK, including KittyPlays, KarQ, and SuperScientific (Danny Winget) influencer campaigns connecting Intel with established tech and gaming creators.",
    metrics: [
      { value: "$400K", label: "Paid media managed (Meta)" },
      { value: "208K+", label: "Paid clicks at $0.36 CPC" },
      { value: "35M+", label: "Paid impressions" },
      { value: "4.4M+", label: "Paid video views" },
      { value: "6 yrs", label: "Continuous program ownership" },
      { value: "3 markets", label: "US · Canada · Global" },
    ],
    proofs: [
      "Owned Meta paid social end-to-end: planning, creative, targeting, optimization, and reporting",
      "Sponsored sweepstakes and creator activations with KittyPlays, KarQ, and SuperScientific (Danny Winget)",
      "Recurring monthly + quarterly analytics decks for Intel and Intel Canada stakeholders",
      "Bridged agency, brand, and creator workflows across a 6-year client relationship",
    ],
  },
  {
    slug: "rockland",
    name: "Rocklands Entertainment Inc.",
    sector: "Live Events · Tour Marketing",
    year: "2017 - Present",
    role: "Creative Production & Campaign Execution",
    url: "https://www.rocklandsentertainment.com/",
    summary:
      "Led creative production and paid social execution for tour marketing across Canada and the US, supporting artists and shows including Frank Mills, Scott Woods, Charley Pride, Red Green, Yesterday Once More, Megastars of Country, Carroll Baker, Oh What A Night, and Four By Four. Work spanned video ads, Facebook campaigns, copywriting, regional targeting, and print and digital assets that supported strong ticket sales and sold-out shows.",
    metrics: [
      { value: "310K+", label: "Paid clicks (last 2 yrs)" },
      { value: "16.9M+", label: "Paid impressions" },
      { value: "4.1M+", label: "Reach" },
      { value: "2.35M+", label: "Video views" },
      { value: "9 tours", label: "Active artist campaigns" },
      { value: "100+", label: "Shows supported" },
    ],
    proofs: [
      "Sold-out theatres across Ontario, the Maritimes, and US Midwest tour stops",
      "Video ads, copywriting, regional targeting, and print/digital assets end-to-end",
      "Recurring tour campaigns for Frank Mills, Scott Woods, Charley Pride, Red Green, and more",
      "Tight feedback loop with promoters and box offices for live ticket-velocity adjustments",
    ],
  },
  {
    slug: "waypoint",
    name: "Waypoint Convenience",
    sector: "Convenience Retail",
    year: "2022 - 2024",
    role: "Social Media & Community Manager",
    url: "https://waypointconvenience.com/",
    summary:
      "Managed social and community engagement across B2B and B2C channels for a Canadian convenience retail brand. Ran Instant Win / Snack Stack promotions, sweepstakes, partner activations, and live event coverage that turned everyday products into a real community moment.",
    metrics: [
      { value: "+81%", label: "Audience growth in 2023" },
      { value: "152,919", label: "Instant Win game plays" },
      { value: "1.2M+", label: "Social impressions (campaign)" },
      { value: "+321% YoY", label: "Social impressions lift" },
      { value: "200K+", label: "Engagements YoY" },
      { value: "200+", label: "Waypoint stores" },
    ],
    proofs: [
      "Designed and ran Instant Win / Snack Stack mechanics with 6-figure entry volume",
      "B2B + B2C content programs across Instagram, Facebook, LinkedIn, and TikTok",
      "On-site coverage of trade shows, store openings, and sponsorship activations",
      "Community management and moderation across high-volume comment threads and DMs",
    ],
  },
  {
    slug: "techthings",
    name: "The Tech & Things Show",
    sector: "Owned Media · Web3, Blockchain, Decentralization",
    year: "2018 - 2024",
    role: "Founder, Host & Producer",
    url: "https://www.youtube.com/@scottcbusiness",
    summary:
      "Built and hosted Tech & Things, a long-form podcast and content platform focused on blockchain, Web3, decentralization, and digital communication. Across 550+ episodes, interviewed founders, executives, creators, and technical leaders while distributing across 50+ platforms and building a diversified multi-platform creator presence.",
    metrics: [
      { value: "550+", label: "Episodes produced" },
      { value: "156K+", label: "Total followers" },
      { value: "22.7M+", label: "Impressions" },
      { value: "1.06M+", label: "Video views" },
      { value: "50+", label: "Distribution platforms" },
      { value: "6 yrs", label: "Continuous publishing" },
    ],
    proofs: [
      "Interviewed John McAfee, Andreas Antonopoulos, Naomi Brockwell, and 100+ Web3 founders",
      "Multi-platform distribution across YouTube, X, LinkedIn, podcast networks, and Web3 video platforms",
      "Self-produced: research, booking, hosting, editing, publishing, and community",
      "Audience and recognition that opened sponsor, advisory, and consulting opportunities",
    ],
  },
] as const;

export const cudoSpotlight = {
  intro:
    "CUDO is the engagement that defines my recent work, the deepest, most technically demanding, and most consistently compounding program in the portfolio. Two sister brands, one editorial engine, and a content surface that scaled from blog posts to NVIDIA GTC keynotes.",
  journey: [
    {
      phase: "2024 · Foundation",
      title: "Rebuilt the editorial engine from the ground up",
      body: "Inherited a fragmented content footprint across CUDO Compute and CUDOS. Audited every surface, set a unified voice, mapped the buyer journey for AI builders and enterprises, and stood up a 12-month editorial roadmap covering blog, whitepapers, newsletters, landing pages, and exec ghostwriting.",
    },
    {
      phase: "2024 · Repositioning",
      title: "Sharpened the narrative around AI compute and permissionless infrastructure",
      body: "Translated dense technical concepts, GPU clusters, HPC, sovereign cloud, permissionless Web3 compute, into clear buyer-facing narratives. Repositioned CUDOS as the permissionless layer of the AI compute stack, giving sales and partnerships a story that landed in enterprise and Web3 rooms alike.",
    },
    {
      phase: "2025 · Compounding",
      title: "Took the brand on the road and into every major AI conversation",
      body: "On-site content lead at NVIDIA GTC, Web Summit, and Token2049, live coverage, executive interviews, booth content, and post-event recap engines. Built AI-assisted research and production workflows so a small team could ship like a much larger one without losing the editorial bar.",
    },
    {
      phase: "2025 - 2026 · Authority",
      title: "Sustained, measurable growth across every primary surface",
      body: "Year-over-year lifts on impressions, engagement, video views, and follower growth across X, LinkedIn, YouTube, and Telegram. Long-form output, sales enablement, and exec presence now carry each other, content drives pipeline conversations, not just vanity numbers.",
    },
  ],
  bigWins: [
    {
      label: "NVIDIA GTC",
      headline: "On-site content lead for back-to-back GTC presences",
      detail:
        "Live coverage, executive interviews, and booth content alongside one of the most competitive AI conferences on the planet, with recap engines that kept earning impressions for weeks afterward.",
    },
    {
      label: "Permissionless compute",
      headline: "Repositioned CUDOS as the permissionless layer for AI compute",
      detail:
        "Built a category-defining narrative that bridges enterprise AI buyers and the Web3 community, used across blog, sales decks, partner conversations, and exec talking points.",
    },
    {
      label: "CUDO library",
      headline: "Built a CUDO library of 400+ short clips from 50 long-form interviews",
      detail:
        "Cut, captioned, and packaged a deep video library powering social, sales enablement, and exec presence across both brands, all produced through AI-assisted workflows that protected quality while compounding output.",
    },
    {
      label: "Two brands, one engine",
      headline: "Owned editorial and social for CUDO Compute and CUDOS in parallel",
      detail:
        "End-to-end ownership across X, LinkedIn, YouTube, and Telegram for both brands, keeping a unified voice while serving very different buyers and communities.",
    },
  ],
  signals: [
    "+88% YoY impressions across owned social",
    "+97% YoY engagements & clicks",
    "+205% YoY video views",
    "+92% YoY follower growth",
    "9.2M+ total impressions",
    "400+ short clips from 50 long-form interviews",
    "Coverage at NVIDIA GTC, Web Summit, and Token2049",
    "Editorial program spanning two sister brands",
  ],
} as const;

export const services = [
  {
    n: "01",
    slug: "content-strategy",
    title: "Content Strategy & Editorial Planning",
    body: "Editorial direction, content calendars, and campaign planning that turn complex ideas into clear, useful, and high-impact communication.",
    tagline: "The architecture for narrative authority and durable audience growth.",
    bullets: [
      "Content audits and gap analysis",
      "12-month editorial roadmaps",
      "Voice, tone, and messaging frameworks",
      "Distribution and channel strategy",
    ],
    idealFor: "Scaling B2B and infrastructure brands",
    engagement: "Fractional or project",
    accent: "primary",
    longBody:
      "Content strategy is the editorial system that ties audience, narrative, and channels back to revenue. Every engagement starts with an audit, then maps the buyer journey for technical and high-growth audiences, and produces a 12-month editorial roadmap covering blog, social, sales enablement, partnerships, and exec presence. The output is a repeatable system, not a one-off campaign.",
    deliverables: [
      "Content audit across owned and earned surfaces",
      "Audience, narrative, and channel mapping",
      "12-month editorial roadmap and content calendar",
      "Voice, tone, and messaging frameworks",
      "Distribution, repurposing, and reporting playbook",
    ],
    relatedCaseSlug: "cudo",
    relatedCaseLabel: "How this shaped CUDO",
  },
  {
    n: "02",
    slug: "copywriting",
    title: "Copywriting & Messaging",
    body: "Sharpened positioning, brand voice, and copy that builds trust and drives action, far past surface-level engagement.",
    tagline: "High-stakes words that turn skeptics into customers.",
    bullets: [
      "Landing pages and conversion paths",
      "B2B email sequences",
      "Sales and pitch narratives",
      "Brand voice and positioning",
    ],
    idealFor: "Founder-led and D2C brands",
    engagement: "Project or retainer",
    accent: "violet",
    longBody:
      "Copy that earns trust and drives action across landing pages, B2B email sequences, sales and pitch narratives, exec ghostwriting, and brand voice. Every line is built to do a job: convert, qualify, retain, or move a deal forward, with positioning that makes a complex product easy to choose.",
    deliverables: [
      "Landing pages and conversion paths",
      "B2B email sequences and nurture flows",
      "Sales decks and pitch narratives",
      "Brand voice, positioning, and messaging",
      "Exec ghostwriting for LinkedIn and X",
    ],
    relatedCaseSlug: "thunderbolt",
    relatedCaseLabel: "Read the Thunderbolt story",
  },
  {
    n: "03",
    slug: "social-media",
    title: "Social Media & Community Growth",
    body: "Social content and community strategies that build presence, deepen audience connection, and create long-term value.",
    tagline: "Engaged communities, not just vanity follower counts.",
    bullets: [
      "Platform-specific strategy",
      "Short-form video and content systems",
      "Community management",
      "Campaign and partner activations",
    ],
    idealFor: "Creator-led and consumer brands",
    engagement: "Embedded or fractional",
    accent: "electric",
    longBody:
      "End-to-end ownership of social and community across the surfaces that actually move the business: LinkedIn, X, Instagram, YouTube, TikTok, Discord, Telegram. Built around platform-specific strategy, short-form video systems, community moderation, and partner activations, and measured by engagement quality rather than vanity follower counts.",
    deliverables: [
      "Platform-specific strategy and editorial calendars",
      "Short-form video and content production systems",
      "Community management, moderation, and DM workflows",
      "Campaign, sweepstakes, and partner activations",
      "Reporting tied to pipeline, conversion, or retention",
    ],
    relatedCaseSlug: "waypoint",
    relatedCaseLabel: "Inside the Waypoint build",
  },
  {
    n: "04",
    slug: "ai-workflows",
    title: "Custom AI Tools, Models & Pipelines",
    body: "Custom AI tools and models for internal and external use, from content and image pipelines to internal knowledge bases, news engines, and agent-assisted workflows.",
    tagline: "Custom AI tooling that ships real work, not demos.",
    bullets: [
      "Custom AI tools and fine-tuned models",
      "Image, video, and content generation pipelines",
      "Internal knowledge bases and RAG search",
      "News, research, and reporting engines",
    ],
    idealFor: "Teams building real AI tooling, not toy demos",
    engagement: "Project or advisory",
    accent: "coral",
    longBody:
      "Custom AI tooling built around how your team actually works. Engagements cover customized AI tools and models for internal and external use, image and video generation pipelines, end-to-end content production pipelines, news and research engines, internal knowledge bases and RAG search, agent-assisted workflows, and the QA gates and team enablement that keep it all repeatable. Built with the same editorial judgement applied to every other surface, so the AI ships real work instead of toy demos.",
    deliverables: [
      "Custom AI tools, agents, and fine-tuned models",
      "Image, video, and content generation pipelines",
      "Internal knowledge bases and RAG search",
      "News, research, and reporting engines",
      "QA gates, prompt libraries, and team enablement",
    ],
    relatedCaseSlug: "cudo",
    relatedCaseLabel: "See AI tooling in action at CUDO",
  },
  {
    n: "05",
    slug: "technical-writing",
    title: "Technical Writing & Long-form Blogs",
    body: "Deeply researched technical writing and long-form blogs that turn complex products, protocols, and infrastructure into clear, credible reading.",
    tagline: "Technical depth, made readable, on a real publishing cadence.",
    bullets: [
      "Long-form blog posts and pillar pages",
      "Whitepapers, briefs, and technical explainers",
      "Developer- and analyst-grade documentation",
      "Subject-matter interviews and ghostwriting",
    ],
    idealFor: "AI, cloud, Web3, cybersecurity, and infrastructure brands",
    engagement: "Project or retainer",
    accent: "primary",
    longBody:
      "Long-form writing that holds up to a technical reader. Covers blog posts, pillar pages, whitepapers, technical explainers, developer- and analyst-facing documentation, and exec ghostwriting, with subject-matter interviews and source review built in. The output is technical content that ranks, gets cited, and earns trust with the people who actually evaluate your product.",
    deliverables: [
      "Long-form blog posts and pillar pages",
      "Whitepapers, briefs, and technical explainers",
      "Developer and analyst documentation support",
      "Subject-matter interviews and source review",
      "Exec ghostwriting on technical topics",
    ],
    relatedCaseSlug: "cudo",
    relatedCaseLabel: "Technical writing at CUDO",
  },
  {
    n: "06",
    slug: "newsletter",
    title: "Newsletter Management & Distribution",
    body: "Newsletter strategy, writing, and distribution systems that turn an email list into a durable, owned audience and pipeline channel.",
    tagline: "An owned audience channel that compounds every week.",
    bullets: [
      "Newsletter strategy and positioning",
      "Writing, editing, and production",
      "List growth, segmentation, and lifecycle",
      "Cross-platform distribution and repurposing",
    ],
    idealFor: "Founders, creators, and B2B brands building an owned audience",
    engagement: "Project or retainer",
    accent: "electric",
    longBody:
      "End-to-end ownership of a newsletter, from strategy and positioning to writing, production, scheduling, and distribution. Covers list growth, segmentation, lifecycle and onboarding flows, sponsorship setup, and cross-platform repurposing into social, podcast, and blog. Built so a newsletter becomes a real audience and pipeline channel, not another inbox tax.",
    deliverables: [
      "Newsletter strategy, positioning, and cadence plan",
      "Writing, editing, and production each issue",
      "List growth, segmentation, and lifecycle flows",
      "Cross-platform distribution and repurposing",
      "Reporting on opens, clicks, and conversion",
    ],
    relatedCaseSlug: "techthings",
    relatedCaseLabel: "Newsletter inside the Tech & Things system",
  },
  {
    n: "07",
    slug: "paid-advertising",
    title: "Paid Advertising: Google, Meta & More",
    body: "Paid media strategy and management across Google, Meta, LinkedIn, and X, built around clear offers, sharp creative, and conversion-tracked outcomes.",
    tagline: "Paid media tied to real pipeline, not vanity impressions.",
    bullets: [
      "Google Ads (Search, PMax, YouTube)",
      "Meta Ads (Facebook and Instagram)",
      "LinkedIn and X paid campaigns",
      "Creative, landing pages, and tracking",
    ],
    idealFor: "Founder-led and B2B brands ready to spend on demand",
    engagement: "Project or retainer",
    accent: "coral",
    longBody:
      "Paid media strategy and hands-on management across Google Ads (Search, Performance Max, YouTube), Meta (Facebook and Instagram), LinkedIn, and X. Engagements cover offer and audience strategy, creative direction, landing page and conversion path review, campaign build, ongoing optimisation, and reporting tied to pipeline and revenue, so paid spend compounds with the rest of the content and brand work.",
    deliverables: [
      "Paid media strategy and channel mix",
      "Campaign build, creative direction, and copy",
      "Landing page and conversion path review",
      "Tracking, attribution, and reporting setup",
      "Ongoing optimisation and spend management",
    ],
    relatedCaseSlug: "waypoint",
    relatedCaseLabel: "Paid and organic working together",
  },
  {
    n: "08",
    slug: "web-presence",
    title: "Website Strategy & AI-Assisted Builds",
    body: "Fast, strategic websites built around clear messaging, clean structure, and AI-assisted production.",
    tagline: "Sharp messaging and shipping speed for founder-led sites.",
    bullets: [
      "Website strategy and sitemap",
      "Landing page copy and structure",
      "AI-assisted build support (Lovable)",
      "Website QA and launch support",
    ],
    idealFor: "Consultants, founders, and small service businesses",
    engagement: "Project or sprint",
    accent: "pink",
    longBody:
      "Strategic websites built around clear messaging, clean structure, and AI-assisted production with tools like Lovable. Engagements cover website strategy, sitemap and page structure, landing page copy, build support, conversion-focused messaging, QA, and basic launch support, so consultants, creators, freelancers, small service businesses, and tech startups get a fast first site that actually converts.",
    deliverables: [
      "Website strategy and sitemap",
      "Landing page copy and conversion-focused messaging",
      "Lovable build support and component direction",
      "Portfolio and personal brand sites",
      "Website QA and basic launch support",
    ],
    relatedCaseSlug: "thunderbolt",
    relatedCaseLabel: "See a website-led narrative in action",
  },
  {
    n: "09",
    slug: "positioning-audits",
    title: "Positioning, Personal Brand & Marketing Audits",
    body: "A focused audit of how you or your brand shows up: resume, LinkedIn, website, social, content, and AI workflows, with clear next moves.",
    tagline: "A sharper narrative and a focused read of what to do next.",
    bullets: [
      "Resume, LinkedIn, and personal brand audit",
      "Website, social, and content audit",
      "AI workflow and competitor audit",
      "Prioritised next moves and roadmap",
    ],
    idealFor: "Operators, founders, and teams scoping their next move",
    engagement: "Project or sprint",
    accent: "violet",
    longBody:
      "Two related entry offers in one. On the personal side, a focused audit of how you show up across resume, LinkedIn, personal site, and social proof, with headline and About rewrites, experience cleanup, and founder or consultant bios. On the brand side, a marketing audit covering website messaging, social presence, content and newsletter strategy, AI workflows, competitor content, and conversion paths. The output is a clear read of what's working, what isn't, and the highest-leverage next moves.",
    deliverables: [
      "Resume, LinkedIn, and personal brand audit",
      "Website, social, and content audit",
      "AI workflow and competitor audit",
      "Prioritised recommendations and next steps",
      "Optional follow-on engagement plan",
    ],
    relatedCaseSlug: "techthings",
    relatedCaseLabel: "See the personal brand work",
  },
  {
    n: "10",
    slug: "creator-systems",
    title: "Podcast, Interviews & Content Repurposing",
    body: "Podcast strategy, hosted interviews with your execs or guests, and full repurposing pipelines, for founder-led shows and company brands alike.",
    tagline:
      "Hosted interviews and long-form production, distribution, and repurposing as a system.",
    bullets: [
      "Hosted interviews with execs, customers, or guests",
      "Podcast strategy, guest research, and run-of-show",
      "Clips and repurposing across YouTube, social, and newsletters",
      "Founder and company interview content systems",
    ],
    idealFor: "Founders, creators, and B2B brands running a show",
    engagement: "Project or retainer",
    accent: "coral",
    longBody:
      "Built on Tech & Things, this offer covers two sides of the same system. On one side, hosted interviews: I can interview your executives, customers, or guests on behalf of your brand, or co-host a company show, with research, question development, and run-of-show handled end-to-end. On the other side, the production and distribution pipeline: podcast strategy, guest research, episode and YouTube descriptions, clips and repurposing across social, newsletter tie-ins, social launch kits, and founder or company interview content systems, so every long-form conversation compounds into weeks of multi-platform content.",
    deliverables: [
      "Hosted interviews with your execs, customers, or guests",
      "Podcast strategy, guest research, and run-of-show",
      "Interview question development and prep docs",
      "Episode, YouTube, and newsletter descriptions",
      "Clips and repurposing plans across social",
      "Founder and company interview content systems",
    ],
    relatedCaseSlug: "techthings",
    relatedCaseLabel: "Inside the Tech & Things system",
  },
] as const;

export const skills = [
  "Content Strategy",
  "Editorial Planning",
  "Copywriting",
  "Messaging",
  "Social Media Strategy",
  "Community Management",
  "Brand Positioning",
  "Audience Growth",
  "Engagement Strategy",
  "Campaign Planning",
  "Marketing Analytics",
  "Content Operations",
  "Performance Optimization",
  "AI-Assisted Workflows",
] as const;

export const brands = [
  { name: "CUDO Ventures", url: "https://www.cudoventures.com/" },
  { name: "CUDOS", url: "https://cudos.org/" },
  { name: "CUDO Compute", url: "https://www.cudocompute.com/" },
  { name: "Waypoint Convenience", url: "https://waypointconvenience.com/" },
  { name: "Intel", url: "https://www.intel.com/" },
  { name: "Thunderbolt Technologies", url: "https://www.thunderbolttechnology.net/" },
  { name: "Rocklands Entertainment Inc.", url: "https://www.rocklandsentertainment.com/" },
  { name: "Daylite", url: "https://www.marketcircle.com/daylite" },
  { name: "MMK Marketing", url: "https://www.mmkmarketing.ca/" },
  { name: "Bright/Shift", url: "https://www.brightshift.co.uk/" },
  { name: "BeInCrypto", url: "https://beincrypto.com/" },
  { name: "Ontario Tech University (OTU)", url: "https://ontariotechu.ca/" },
] as const;

export const additionalServices = [
  "Brand & Editorial Voice",
  "Long-form Writing",
  "Landing Page Copy",
  "Newsletter Strategy",
  "Content Audits & Roadmaps",
  "SEO Content Briefs",
  "Sales Enablement Assets",
  "X / LinkedIn Ghostwriting",
  "Short-form Video Direction",
  "Community Management",
  "Reporting & Analytics",
  "AI Prompt Libraries",
  "AI-Assisted Research",
  "AI Editorial QA",
  "Workflow Automation",
  "Automated Publishing Pipelines",
  "Influencer & Partner Activations",
  "Paid Social Campaign Support",
  "Podcast & Interview Production",
  "Video Editing",
  "Graphic Design",
  "Sweepstakes & Contesting",
  "Web3 & AI Positioning",
] as const;

export const techThingsInterviews = {
  playlists: [
    "https://www.youtube.com/playlist?list=PLyzkXbUXKxGQgUZFu7oEVKqgXaoKxB_y-",
    "https://www.youtube.com/playlist?list=PLyzkXbUXKxGRlhlI6RKXRaYIXcPeSUis0",
    "https://www.youtube.com/playlist?list=PLyzkXbUXKxGTdCIeFH9AwkggxMKZknDRy",
  ],
  groups: [
    {
      title: "Highest public recognition",
      names: [
        {
          name: "John McAfee (Philanthropist & Creator of McAfee Security Systems)",
          url: "https://www.youtube.com/watch?v=SQoHQXgidRU",
          featured: true,
        },
        {
          name: "Andreas M. Antonopoulos (Bitcoin educator, author of Mastering Bitcoin)",
          url: "https://youtu.be/aVdmJ5Kmn3Y",
        },
        { name: "Naomi Brockwell (Privacy advocate, NBTV)", url: "https://youtu.be/iTZkxJFHUXU" },
        { name: "Chris (MMCrypto)", url: "https://youtu.be/znmTsTgcuNU" },
        { name: "The Moon Carl (Carl Runefelt, The Moon)", url: "https://youtu.be/bmFlo19oSBk" },
        { name: "Wendy O (CryptoWendyO)", url: "https://youtu.be/jEZRBte32TE" },
        { name: "Hashoshi (Crypto educator & analyst)", url: "https://youtu.be/oMPp9hZStEI" },
        { name: "Crypto Stache (Crypto educator & creator)", url: "https://youtu.be/7s52uJS0s5o" },
        { name: "Kenn Bosak (Crypto educator & host)", url: "https://youtu.be/DWkA2MWRsLA" },
        { name: "Crypto Michaël (Trader & analyst)", url: "https://youtu.be/DTHHPE6Mc4A" },
        { name: "Rachel Siegel (CryptoFinally)", url: "https://youtu.be/WVDILV2a2UE" },
        { name: "Joel Valenzuela (Dash News)", url: "https://youtu.be/l_FiBxqJ37o" },
        { name: "Marc De Mesel (Investor & YouTuber)", url: "https://youtu.be/6uw10KgbKKk" },
        { name: "Eryka Gemma (Bank of Eryka)", url: "https://youtu.be/Cp8ZnMUXKH8" },
        { name: "Matt Aaron (Bitcoin.com)", url: "https://youtu.be/SzGRz7OQqz8" },
        { name: "Dave (TruthRaider)", url: "https://youtu.be/9Q2snnfSKfI" },
        {
          name: "Jeff Pulver, Debrief (pioneered VoIP, helped start Mozilla Firefox)",
          url: "https://youtu.be/n8DHTCq98OQ",
        },
        { name: "Luke Mulks (Brave Browser)", url: "https://youtu.be/cznste8MaM4" },
        { name: "Colin Pape (Presearch)", url: "https://youtu.be/n8DL0sSK1A4" },
        { name: "Brantly Millegan (Ethereum Name Service)", url: "https://youtu.be/-Oz_QKouV5c" },
        { name: "Ryan Taylor (Dash Core Group)", url: "https://youtu.be/k2HqTPtNMGY" },
        { name: "Bradley Kam (Unstoppable Domains)", url: "https://youtu.be/YHQo2r0aG_E" },
        "Chad Barraford (Thorchain)",
        { name: "Serjeg Kotliar (Bitrefill)", url: "https://youtu.be/euEnDvB8aGQ" },
        { name: "Jean-Marc Jacobson (RealT)", url: "https://youtu.be/Bt2xg0KO65I" },
        { name: "Remy Jacobson (RealT)", url: "https://youtu.be/Bt2xg0KO65I" },
      ],
    },
    {
      title: "Web3 & crypto founders, executives, and builders",
      names: [
        { name: "Bill Ottman, Minds.com", url: "https://youtu.be/97P1fLSdEWs" },
        { name: "Rob Viglione, Horizen", url: "https://youtu.be/CrEWtPXqFOg" },
        { name: "Paul Puey, Edge", url: "https://youtu.be/5vjb5gYOwes" },
        { name: "Jonathan Chester, Bitwage", url: "https://youtu.be/g4VRjy4yHxk" },
        { name: "Jack Tao, Phemex", url: "https://youtu.be/68aDnn6Bbw8" },
        { name: "Veronica Wong, SafePal", url: "https://youtu.be/i1mDqarljKM" },
        { name: "Rafael Cosman, TrustToken", url: "https://youtu.be/5fz6hAneN-I" },
        { name: "Deniz Omer, Kyber Network", url: "https://youtu.be/-jn_lCuYLLE" },
        { name: "Ian Friend, Ferrum Network", url: "https://youtu.be/CRbGqwR3DZE" },
        { name: "Andrew Levine, Steemit Inc. / Open Orchard", url: "https://youtu.be/LJIbh1mPfYc" },
        { name: "Elizabeth Powell, Steemit Inc.", url: "https://youtu.be/ro7-Y_K7aEw" },
        { name: "Julian Chandra, LBRY", url: "https://youtu.be/WmbzRY-t9Og" },
        { name: "Alex Grintsvayg, LBRY", url: "https://youtu.be/saHCssL7YlY" },
        { name: "Dan Hensley, 3Speak", url: "https://youtu.be/jvGuam-5GWQ" },
        { name: "Jayson Tan, Torum", url: "https://youtu.be/v68KOOcrAos" },
        "Daniel Satchkov, Bastyon",
        { name: "Khaleel Kazi, LeoFinance", url: "https://youtu.be/LaH64sF-b2I" },
        { name: "Joe Roets, Den.Social", url: "https://youtu.be/3AJHY4HcNaU" },
        { name: "Rob McNealy, TUSC", url: "https://youtu.be/wyuB2rIFZn4" },
        { name: "Joe Bender, Blockstack", url: "https://youtu.be/qNZvr9zt93A" },
        { name: "Jason Goldberg, Pepo", url: "https://youtu.be/A7Zejx_yYcI" },
        { name: "Mark Van Rijmenam, Datafloq", url: "https://youtu.be/K5dDMNPNfR0" },
        { name: "Ankit Bhatia, Sapien", url: "https://youtu.be/o5TWiVVWdfk" },
        { name: "Kartik Mandaville, Springrole", url: "https://youtu.be/9WOitR5aKro" },
        { name: "Rohan Agarwal, Cypherock", url: "https://youtu.be/tMdFbhIu_8Y" },
        { name: "Dawson Botsford, Earni.fi", url: "https://youtu.be/Kr8u6gmA--s" },
        { name: "Alex Melikhov, Equilibrium", url: "https://youtu.be/S-EYlgC5JoM" },
        { name: "Tony Perkins, Bankroll", url: "https://youtu.be/TEqKX4GPblY" },
        { name: "Erica Stanford, Crypto Wars", url: "https://youtu.be/1E1cu2CmfM4" },
        { name: "Uri Klarman, Bloxroute", url: "https://youtu.be/JWBhLWmGIw4" },
        { name: "Gabriel Rene, Verses.io", url: "https://youtu.be/r86TiJB-SYY" },
        { name: "David Gold, Dapix / FIO", url: "https://youtu.be/-nCE9P5imBw" },
      ],
    },
    {
      title: "Platform, community, and blockchain project leaders",
      names: [
        { name: "Adrien (@Heimindanger), DTube", url: "https://youtu.be/phEP6lkRdS0" },
        { name: "Seth Estrada (MineYour.Biz)", url: "https://youtu.be/rrW_W752Yds" },
        "Myles Wakeham",
        "Pascal Thellman, Bounty0x",
        { name: "Richard Sanders, CipherBlade", url: "https://youtu.be/KJn1JCLr7k4" },
        { name: "Stephano Covolan, Korporatio", url: "https://youtu.be/irD5cKHQk3Y" },
        { name: "Mark Anstead, Hydro / Numio", url: "https://youtu.be/VNY4MBuVjG8" },
        { name: "Aly Kassam, OneLedger", url: "https://youtu.be/JOIrnQzEgfQ" },
        { name: "Jonathan Brown, Mix Acuity", url: "https://youtu.be/hU6ZHgH6tEI" },
        { name: "David Zhou, TokenTuber", url: "https://youtu.be/1rhcAkOdhkw" },
        { name: "Andrew Huntley, Daps Coin", url: "https://youtu.be/D5vxzzph3os" },
        { name: "Christopher Kramer, SoMee", url: "https://youtu.be/456RcumFIZA" },
        { name: "Vadim Zolotokyrlin, Holdex", url: "https://youtu.be/dl54IpdqtsE" },
        { name: "Jacques Whales, Discussions.app", url: "https://youtu.be/OMw6VyqXYwU" },
        { name: "Paul Motschall, Discussions.app", url: "https://youtu.be/OMw6VyqXYwU" },
        { name: "Zac Nien, Contentos", url: "https://youtu.be/WnM7w5Sq-SE" },
        { name: "Steven Zambrom, BeatzCoin / VIBRAvid", url: "https://youtu.be/wptkx2iaK1M" },
        { name: "Ricard Schiller, BlockBase", url: "https://youtu.be/MDGDSkSGAQc" },
        { name: "Diogo Bulha, BlockBase", url: "https://youtu.be/MDGDSkSGAQc" },
        { name: "Hans Koning, DigiByte Foundation", url: "https://youtu.be/E1LN8qnn_8g" },
        { name: "Ivo Georgiev, AdEx Network", url: "https://youtu.be/dGXkuXKKXLM" },
        { name: "Tito Titov, JellySwap", url: "https://youtu.be/LWPzbDP7EbQ" },
        { name: "DDRFr33k, Vimm.TV", url: "https://youtu.be/RspPn4xyMPE" },
        { name: "Daniel Pittman, EtherChest", url: "https://youtu.be/ffQpTIypvQE" },
        { name: "Alex Kampa, Sikoba Network", url: "https://youtu.be/oIy1Tpek6d8" },
        { name: "Kyle Collier, Phaze", url: "https://youtu.be/R1AImlPJx48" },
        { name: "Nicole Grinstead", url: "https://youtu.be/kA2PjTVznQs" },
        { name: "Rice Crypto", url: "https://youtu.be/nai5tcEHYDc" },
      ],
    },
  ],
} as const;

import emma from "@/assets/testimonials/emma.webp";
import emmanuel from "@/assets/testimonials/emmanuel.webp";
import madeleine from "@/assets/testimonials/madeleine.webp";
import nancy from "@/assets/testimonials/nancy.webp";
import james from "@/assets/testimonials/james.webp";
import shiori from "@/assets/testimonials/shiori.webp";
import andrew from "@/assets/testimonials/andrew.webp";
import leona from "@/assets/testimonials/leona.webp";
import kaitlin from "@/assets/testimonials/kaitlin.webp";
import kir from "@/assets/testimonials/kir.webp";
import oliwer from "@/assets/testimonials/oliwer.webp";
import marie from "@/assets/testimonials/marie.webp";
import brian from "@/assets/testimonials/brian.webp";

export const testimonials = [
  {
    name: "Brian Edwards",
    title: "President at Rocklands Entertainment Inc.",
    image: brian,
    quote:
      "Scott Cunningham is the most efficient person I have ever worked with. His extensive knowledge speaks for itself with every project he does for us. Scott's expertise in promoting a recent Red Green North American tour and Red's latest book release lead to tremendous results. I would, without hesitation, recommend Scott Cunningham for any project.",
  },
  {
    name: "Marie Nicola",
    title: "Journalist at The Debrief · formerly MMK Marketing",
    image: marie,
    quote:
      "One of the highlights of joining MMK Marketing is the opportunity to have Scott on my team. In the year we've worked together, he has really asserted himself as a capable community manager leading in advanced relationship building across the social web and growth strategies. I appreciate him for the quality of work he provides and the level of trust he garners from teammates and clients alike.",
  },
  {
    name: "Emma Mkrtchian",
    title: "Fractional CMO at EMK Marketing",
    image: emma,
    quote:
      "Scott is not only an amazing content creator but also one of those rare people you can always count on. He made my life so much easier, and I knew I could take some time off and everything would still get done. He has this calm confidence that makes everything feel more manageable.",
  },
  {
    name: "Emmanuel Ohiri",
    title: "SEO Strategy & Writing at CUDO",
    image: emmanuel,
    quote:
      "Scott led our social program for two years at CUDO. He crafted engaging campaigns, measured their impact, and applied those insights to refine our approach. His creativity, analytical mindset, and video production skills elevated our organic growth.",
  },
  {
    name: "Madeleine Soden",
    title: "Digital Designer at CUDO",
    image: madeleine,
    quote:
      "Scott is the most versatile content lead I've ever worked with. A genuine jack-of-all-trades who thrives on new challenges. Exceptionally fast, deeply knowledgeable in tech and social, and maintains a calm, steady presence even in high-pressure environments.",
  },
  {
    name: "Nancy Abdalla",
    title: "Founder at Weaver+",
    image: nancy,
    quote:
      "Scott has been instrumental in establishing and growing our tech client's social media program. He's sharp, insightful, creative, and always comes with great ideas. His work ethic is top notch, incredibly reliable, and always delivers great work on time.",
  },
  {
    name: "James Hymers",
    title: "Business Development Manager at Chartersync",
    image: james,
    quote:
      "Scott's ability to understand the target audience and stay ahead of industry trends resulted in engaging content that increased conversions. His exceptional copywriting, from attention-grabbing headlines to emotionally engaging stories, drove real results.",
  },
  {
    name: "Shiori Mine",
    title: "Digital Marketing Specialist",
    image: shiori,
    quote:
      "Scott is a rare talent and by far one of the best social media marketers and community managers I have had the pleasure to work with. World-class work ethic. He always delivers on time and takes full ownership of his projects from beginning to end.",
  },
  {
    name: "Andrew Wahl",
    title: "Content Marketing Strategist",
    image: andrew,
    quote:
      "Scott's sharp and insightful approach to community management played a key role in a major tech company program. He demonstrated a keen understanding of the audience and offered concise, creative recommendations for how to engage them.",
  },
  {
    name: "Leona Hobbs",
    title: "Group Account Director at iProspect",
    image: leona,
    quote:
      "Scott was a fabulous collaborator and strong contributor to our success with owned and paid social for Thunderbolt 3 / Intel. First he helped secure the business from a competitor, then executed with excellence. I never needed to worry about Scott.",
  },
  {
    name: "Kaitlin Argeaux",
    title: "Head of Events at CUDO",
    image: kaitlin,
    quote:
      "Scott is one of those rare people who combines creativity with real operational reliability. Consistently responsive, organised, and on top of his work. Collaborative, supportive across teams, solution-oriented, and always willing to jump in where needed.",
  },
  {
    name: "Kirthana Devaser",
    title: "Product Marketing Lead at CUDO",
    image: kir,
    quote:
      "Scott is the definition of a team player. Hands down one of the most reliable and easy-to-work-with people I've come across. What sets him apart is how plugged in he is to Web3, AI and tech, he gets the nuances, the culture, and how to make things land.",
  },
  {
    name: "Oliwer Nastaziak",
    title: "Community Manager at CUDOS",
    image: oliwer,
    quote:
      "Scott impressed with his sharp creative instincts and strategic mindset. Whether crafting compelling content, managing social channels, or coordinating campaigns, he consistently brings clarity, energy, and results. No ego, just a genuine willingness to get things right.",
  },
] as const;
